import React from 'react';
import style from './style.module.scss';
import SpainFlag from './es.svg';
import PortugalFlag from './pt.svg';

export default function LangIcon({ lang }) {
    if (lang === 'es') {
        return <img className={style.iconStyle} src={SpainFlag} />;
    } else if (lang === 'pt') {
        return <img className={style.iconStyle} src={PortugalFlag} />;
    }
    return null;
}
